export default __webpack_public_path__ + "static/media/20A0BA91-C821-41B0-9D1B-34C81F8BF803.8d325ee9.jpeg";